import TKShowMore from '@tk/components/tk.show.more';

export default class GTAShowMore extends TKShowMore {
    showingLines?: number;

    constructor() {
        super();
        this.showingLines = Number(this.getAttribute('data-tk-showing-lines')) || undefined;

        if (this.showingLines) {
            this.minHeight = this.getLineHeight() * this.showingLines;
        }
    }

    getLineHeight() {
        const innerstElement = this.content!.children[0];
        return parseFloat(getComputedStyle(innerstElement).lineHeight);
    }
}
